import React from "react";
import "./Services.css";
import { FaBalanceScale, FaFileContract, FaUniversity, FaGavel  } from "react-icons/fa";

export default function Services() {
  return (
    <section className="services-section">
      {/* INTRO */}
      <div className="services-intro" id="servicos">
        <h2>
          SERVIÇOS OFERTADOS
        </h2>
      </div>

      {/* CARDS DE SERVIÇOS */}
      <div className="services-cards">
        <div className="servicecard">
          <FaBalanceScale className="servicecard-icon" />
          <h4>Consultoria Jurídica:</h4>
          <p>
           Análise
            técnica de situações específicas, com orientação personalizada para
            esclarecer dúvidas, indicar caminhos legais e auxiliar na tomada de
            decisões de forma segura e informada.
          </p>
        </div>

        <div className="servicecard">
          <FaFileContract className="servicecard-icon" />
          <h4>Assessoria Jurídica:</h4>
          <p>
             Acompanhamento contínuo das demandas do cliente, oferecendo suporte
            jurídico regular e orientação constante para prevenir problemas
            futuros.
          </p>
        </div>

        <div className="servicecard">
          <FaGavel   className="servicecard-icon" />
          <h4>Advocacia Preventiva:</h4>
          <p>
           Atuação
            voltada a evitar litígios, por meio da análise de riscos, revisão de
            documentos, estudo de cenários e implementação de estratégias que
            garantam segurança jurídica antes de eventuais conflitos surgirem
          </p>
        </div>

        <div className="servicecard">
          <FaUniversity  className="servicecard-icon" />
          <h4>Advocacia Contenciosa:</h4>
          <p>
           A Representação do cliente em processos judiciais e administrativos,
            com elaboração de peças, sustentação de defesa ou acusação,
            participação em audiências e condução estratégica da demanda até sua
            resolução.
          </p>
        </div>
      </div>
    </section>
  );
}
